import React from "react";
import "./LearningEdge.css";
import cbse_curriculam1 from "../assets/learning-edge-class.JPG";

const LearningEdge = () => {
  return (
    <div className="learning-section">

      {/* CBSE + Academic */}
      <div className="common-container">
        <h2 className="learning-title">The Learning Edge</h2>

        <h3 className="overview-title">CBSE Curriculum</h3>

        <div className="overview-container">
          <img
            src={cbse_curriculam1}
            alt="CBSE Curriculum"
            className="overview-image"
          />

          <div className="overview-text">
            <h4>CBSE Curriculum at Vivek Vardhini Creative Minds School</h4>

            <p>
              At Vivek Vardhini Creative Minds School, we follow the CBSE
              curriculum, a well-balanced and student-friendly academic
              framework designed to help every child learn with confidence
              and curiosity.
            </p>

            <p>
              CBSE focuses on clear concepts, practical learning, and skill
              development. Subjects are taught in a structured and engaging
              way, helping students understand ideas deeply rather than
              memorizing them. This approach builds a strong foundation in
              academics and prepares students for higher studies and
              competitive exams across India.
            </p>

            <p>
              The curriculum also gives equal importance to sports, arts,
              values, and life skills, ensuring that students grow not just
              academically but also as confident, responsible, and creative
              individuals. With activity-based lessons, interactive
              classrooms, and regular assessments, learning becomes
              enjoyable and stress-free.
            </p>

            <p>
              At Vivek Vardhini Creative Minds School, we blend the strengths of the CBSE curriculum with our child-centered teaching methods to create an environment where every student can discover their talents, think independently, and achieve their best.
            </p>

            <p>
              <strong>
                A future-ready education begins here—rooted in knowledge,
                enriched with creativity, and guided by values.
              </strong>
            </p>
          </div>
        </div>

        {/* Academic Approach */}
        <section className="academic-approach-section">
          <h2 className="academic-approach-title">Our Academic Approach</h2>

          <div className="academic-approach-description">
            <p>
              We at VVCMS offer a holistic and inclusive blend of the CBSE curriculum, enriched with the vision of NEP 2020 and NCF, strictly following prescribed  NCERT syllabus textbooks and CBSE guidelines. Our curriculum is designed  to reach learners at all levels, with a strong emphasis on equity over equality, ensuring every child receives the support they need to succeed. Continuous teacher training and professional development programmes are effectively planned, implemented and monitored to enhance instructional quality. Deeply rooted in the culture, values and rich heritage of our nation, we nurture responsible, confident and future-ready global citizens who take pride in India’s legacy.
            </p>
          </div>
        </section>
      </div>

      {/* Unique Assessment */}
      <section className="unique-assessment-section">
        <div className="common-container">
          <h2 className="section-title">Unique Assessment System</h2>

          <div className="assessment-container">
            <div className="assessment-card">
              <div className="assessment-card-icon">
                <i className="fas fa-laptop-code"></i>
              </div>
              <h3>AI-Generated Assessment</h3>
              <p>
                Each chapter is followed by an AI-generated assessment designed
                to understand each student’s learning progress with precision.
              </p>
            </div>

            <div className="assessment-card">
              <div className="assessment-card-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3>Student Categorization</h3>
              <p>
                Based on their performance, students are grouped into three
                categories, ensuring that each learner receives the right
                level of challenge and support.
              </p>
            </div>

            <div className="assessment-card">
              <div className="assessment-card-icon">
                <i className="fas fa-chalkboard-teacher"></i>
              </div>
              <h3>Reinforcement by Teachers</h3>
              <p>
                Teachers revisit concepts and ensure clarity before the
                second round of assessments, strengthening students'
                understanding and confidence.
              </p>
            </div>

            <div className="assessment-card">
              <div className="assessment-card-icon">
                <i className="fas fa-lightbulb"></i>
              </div>
              <h3>Advanced Level Challenges</h3>
              <p>
                Students receive varying levels of difficulty in the second
                assessment, stimulating advanced thinking while reinforcing
                understanding for others.
              </p>
            </div>

            <div className="assessment-card">
              <div className="assessment-card-icon">
                <i className="fas fa-robot"></i>
              </div>
              <h3>Adaptive Learning</h3>
              <p>
                This system adapts to each student’s learning pace, ensuring
                that all children progress confidently and achieve meaningful
                academic growth.
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default LearningEdge;
